export default "__VITE_ASSET__CLYRZcfv__"